export const SeasonalTag = ({ className = "", testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] ${className}`}>
    <svg viewBox="0 0 20 20" className="w-2.5 h-2.5 text-gold" aria-hidden="true"><path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4z" fill="currentColor" /></svg>
    Seasonal
  </span>
);
